import ReactMarkdown from 'react-markdown';

const markdownComponents = {
  p: ({children}) => (
    <p className="mb-3 last:mb-0 leading-[1.75] text-sm sm:text-base">{children}</p>
  ),
  strong: ({children}) => (
    <strong className="font-semibold text-[#3B1E73]">{children}</strong>
  ),
  em: ({children}) => (
    <em className="italic opacity-85">{children}</em>
  ),
  ul: ({children}) => (
    <ul className="list-disc pl-6 mb-3 space-y-1.5 marker:text-[#3B1E73]/60">{children}</ul>
  ),
  ol: ({children}) => (
    <ol className="list-decimal pl-7 mb-3 space-y-1.5 marker:text-[#3B1E73]/70 [font-variant-numeric:tabular-nums]">{children}</ol>
  ),
  li: ({children}) => (
    <li className="text-sm sm:text-base leading-[1.7] pl-1">{children}</li>
  ),
  hr: () => null,
  h1: ({children}) => (
    <p className="font-bold text-base sm:text-lg mb-2 mt-1 text-[#3B1E73]">{children}</p>
  ),
  h2: ({children}) => (
    <p className="font-bold text-sm sm:text-base mb-2 mt-1 text-[#3B1E73]/90">{children}</p>
  ),
  h3: ({children}) => (
    <p className="font-semibold text-sm sm:text-base mb-1.5 text-[#3B1E73]/80">{children}</p>
  ),
  a: ({children}) => <span>{children}</span>,
  img: () => null,
  code: ({children}) => (
    <code className="bg-white/30 px-1.5 py-0.5 rounded text-xs font-mono">{children}</code>
  ),
  blockquote: ({children}) => (
    <blockquote className="border-l-3 border-[#3B1E73]/30 pl-4 my-2 italic text-[#3B1E73]/80">{children}</blockquote>
  ),
};

const sanitize = (text) =>
  (text || '').replace(/^[-━─┄]{3,}$/gm, '').replace(/\n{3,}/g, '\n\n');

export const OwenMarkdown = ({ children }) => (
  <ReactMarkdown components={markdownComponents}>
    {sanitize(children)}
  </ReactMarkdown>
);

export default OwenMarkdown;
